/**
 * Hero Banner Component
 * Manages auto-rotating tabs with progress indicators
 * @param {number} totalTabs - Number of hero content items
 * @param {number} duration - Duration in ms for each tab (default: 5000)
 */
export function heroBanner(totalTabs, duration = 5000) {
  return {
    activeLink: 0,
    progress: 0,
    duration: duration,
    interval: null,
    progressInterval: null,
    pausedTime: null,
    startTime: null,
    hoveredTab: null,
    totalTabs: totalTabs,
    
    init() {
      this.startAutoRotate();
    },
    
    startAutoRotate() {
      this.progress = 0;
      this.startTime = Date.now();
      this.pausedTime = null;
      
      // Update progress bar
      this.progressInterval = setInterval(() => {
        if (this.pausedTime === null) {
          const elapsed = Date.now() - this.startTime;
          this.progress = Math.min((elapsed / this.duration) * 100, 100);
        }
      }, 50);
      
      // Switch to next tab after duration
      this.interval = setTimeout(() => {
        this.nextTab();
      }, this.duration);
    },
    
    nextTab() {
      this.activeLink = (this.activeLink + 1) % this.totalTabs;
      this.resetAutoRotate();
    },
    
    resetAutoRotate() {
      clearTimeout(this.interval);
      clearInterval(this.progressInterval);
      this.startAutoRotate();
    },
    
    setActiveTab(index) {
      this.activeLink = index;
      this.hoveredTab = index;
    },
    
    pauseAutoRotate(index) {
      this.hoveredTab = index;
      this.pausedTime = Date.now();
      clearTimeout(this.interval);
      clearInterval(this.progressInterval);
    },
    
    resumeAutoRotate() {
      this.hoveredTab = null;
      this.pausedTime = null;
      this.progress = 0;
      this.startTime = Date.now();
      
      // Restart progress updates from 0
      this.progressInterval = setInterval(() => {
        const elapsed = Date.now() - this.startTime;
        this.progress = Math.min((elapsed / this.duration) * 100, 100);
      }, 50);
      
      // Restart rotation timer from beginning
      this.interval = setTimeout(() => {
        this.nextTab();
      }, this.duration);
    }
  };
}
